import React, { useState, useEffect, useCallback } from "react";
import { FilterMatchMode } from "primereact/api";
import ModalHeader from "../../../../Components/Header/ModalHeader";
import { Dialog } from "primereact/dialog";
import "./ANMProfile.scss";
import PropTypes from "prop-types";
import NoRecordFound from "../../../../Shared/Component/NoRecordFound/NoRecordFound";
import { ListOfAshasColumns } from "../../../../Shared/Constant/TableConstants";
import CustomDataTable from "../../../../Shared/Component/CustomTable/CustomDataTable";
import AshaIndividualView from "../AshaIndividualView/AshaIndividualView";
import { useTranslation } from "react-i18next";
import {
  ashaDetailFilterTemplate,
  createDropdownFilterTemplate,
  reminderBodyTemplate,
} from "../../../../Shared/Utils/tableColumns";
import { getGlobalAreaType } from "../../../../Store/Dashboard/DashboardSelectors";
import { useSelector } from "react-redux";
import GetAreaId from "../../../../Shared/Utils/getAreaId";
const ActiveInactiveAnmTable = ({ handleAshaClick, dataList }) => {
  const [ashaName, setAshaName] = useState([]);
  const [selectedItems, setSelectedItems] = useState([]);
  const [totalActivityCount, setTotalActivityCount] = useState([]);
  const [filters, setFilters] = useState(null);
  const areaType = useSelector(getGlobalAreaType);
  const areaId = GetAreaId(areaType);
  const [activeCases, setActiveCases] = useState([]);
  const [subCenterName, setSubCenterName] = useState([]);
  const [joiningDate, setJoiningDate] = useState([]);
  const [paidIncentive, setPaidIncentive] = useState([]);
  const [isAshaProfileModalVisible, setAshaProfileModalVisible] =
    useState(false);
  const [selectedAshaId, setSelectedAshaId] = useState(null);
  const { t } = useTranslation("");

  const instCol = ListOfAshasColumns();

  const initFilters = () => {
    setFilters({
      ashaid: { value: "", matchMode: FilterMatchMode.CONTAINS },
      ashaName: { value: "", matchMode: FilterMatchMode.CONTAINS },
      mobileNo: { value: "", matchMode: FilterMatchMode.CONTAINS },
      totalActiveCases: { value: null, matchMode: FilterMatchMode.EQUALS },
      joiningDate: { value: null, matchMode: FilterMatchMode.EQUALS },
      subcentername: { value: null, matchMode: FilterMatchMode.EQUALS },
      paidIncentive: { value: null, matchMode: FilterMatchMode.EQUALS },
      totalActivityCount: { value: null, matchMode: FilterMatchMode.EQUALS },
      remindersCount: { value: "", matchMode: FilterMatchMode.CONTAINS },
    });
  };
  const closeDialog = () => {
    setAshaProfileModalVisible(false);
  };
  //for dropdown only
  const setComponentStateData = (data) => {
    const extractProperty = (item, property) =>
      item[property] ? [item[property]] : [];
    const totalActivityCounts = data.flatMap((item) =>
      extractProperty(item, "totalActivityCount")
    );
    const subcentername = data.flatMap((item) =>
      extractProperty(item, "subcentername")
    );
    const paidIncentives = data.flatMap((item) =>
      extractProperty(item, "paidIncentive")
    );
    const activeCases = data.flatMap((item) =>
      extractProperty(item, "totalActiveCases")
    );
    const joiningDates = data.flatMap((item) =>
      extractProperty(item, "joiningDate")
    );
    setTotalActivityCount((activity) => [...activity, ...totalActivityCounts]);
    setSubCenterName((subCenterNames) => [...subCenterNames, ...subcentername]);
    setPaidIncentive((paidIncentive) => [...paidIncentive, ...paidIncentives]);
    setActiveCases((activeCase) => [...activeCase, ...activeCases]);
    setJoiningDate((joiningDate) => [...joiningDate, ...joiningDates]);
  };

  //dropdown filter

  useEffect(() => {}, [
    totalActivityCount,
    subCenterName,
    paidIncentive,
    activeCases,
    joiningDate,
  ]);
  //dropdown filter
  const ActiveCaseFilterTemplate = createDropdownFilterTemplate(activeCases, t);
  const subcenterFilterTemplate = createDropdownFilterTemplate(
    subCenterName,
    t
  );
  const paidIncentiveFilterTemplate = createDropdownFilterTemplate(
    paidIncentive,
    t
  );
  const totalactivityFilterTemplate = createDropdownFilterTemplate(
    totalActivityCount,
    t
  );
  const joiningDateFilterTemplate = createDropdownFilterTemplate(
    joiningDate,
    t
  );

  const handleComponentStateUpdate = useCallback(() => {
    setComponentStateData(dataList);
  }, [dataList]);
  const handleDataUpdate = useCallback(() => {
    dataList && handleComponentStateUpdate();
  }, [dataList, handleComponentStateUpdate]);
  useEffect(() => {
    handleDataUpdate();
  }, [dataList, handleDataUpdate]);
  useEffect(() => {
    initFilters();
  }, [
    dataList,
    totalActivityCount,
    subCenterName,
    paidIncentive,
    activeCases,
    joiningDate,
  ]);

  const handleAshaNameClick = (ashaid, name, type) => {
    setSelectedAshaId(ashaid);
    setAshaProfileModalVisible(true);
    setAshaName(name);
  };
  const handleAshaName = (rowData) => {
    const handleKeyDown = () => {
      handleAshaNameClick(rowData.ashaid, 0);
    };
    const handleKey = (e) => {
      if (e.key === "Enter") {
        handleKeyDown();
      }
    };
    return (
      <div
        className="asha-selection text-left"
        onClick={() => handleAshaNameClick(rowData.ashaid, rowData.ashaName, 0)}
        onKeyDown={handleKey}
      >
        {rowData.ashaName}
      </div>
    );
  };
  const handleActivity = (rowData) => (
    <div className="asha-selection text-left">{rowData.totalActivityCount}</div>
  );

  const bodyMethods = {
    ashaName: handleAshaName,
    totalActivityCount: handleActivity,
    remindersCount: reminderBodyTemplate,
  };
  const filterMethods = {
    ashaName: (options) => ashaDetailFilterTemplate(options, t),
    ashaid: (options) => ashaDetailFilterTemplate(options, t),
    mobileNo: (options) => ashaDetailFilterTemplate(options, t),
    subcentername: subcenterFilterTemplate,
    totalActiveCases: ActiveCaseFilterTemplate,
    joiningDate: joiningDateFilterTemplate,
    paidIncentive: paidIncentiveFilterTemplate,
    totalActivityCount: totalactivityFilterTemplate,
    remindersCount: (options) => ashaDetailFilterTemplate(options, t),
  };
  function hasData(data) {
    return data && data.length > 0;
  }
  return (
    <>
      <div data-testid="anm-table-container">
        <div className="flex justify-content-end"></div>
        <div className="mt-2">
          {hasData(dataList) ? (
            <>
              <CustomDataTable
                columns={instCol}
                className={"ANMTable"}
                data={dataList}
                dataKey="ashaid"
                resizeable
                selectedItems={selectedItems}
                onSelectionChange={(e) => setSelectedItems(e.value)}
                filters={filters} // Pass filters to the CustomDataTable
                filterMethods={filterMethods}
                bodyMethods={bodyMethods}
                areaId={areaId}
              />
              <p>
                {" "}
                {dataList.length} {t("Totalrecord")}{" "}
              </p>
            </>
          ) : (
            <NoRecordFound />
          )}
        </div>
      </div>
      {isAshaProfileModalVisible && (
        <Dialog
          className="cockpit-dialog"
          visible={isAshaProfileModalVisible}
          modal={true}
          position={"center"}
          draggable={false}
          resizable={false}
          onHide={() => setAshaProfileModalVisible(false)}
          closeOnEscape={false}
          header={
            <ModalHeader onClose={closeDialog} backText={t("BacktoTable")} />
          }
        >
          <AshaIndividualView
            ashaId={selectedAshaId}
            name={ashaName}
            isStatus={true}
          />
        </Dialog>
      )}
    </>
  );
};

ActiveInactiveAnmTable.propTypes = {
  handleAshaClick: PropTypes.func.isRequired,
  dataList: PropTypes.array.isRequired,
};

export default ActiveInactiveAnmTable;
